export default {
  rules_no_points_month:'该月没有获得积分',
  rules_description_title:'积分规则说明：',
  rules_description01:'1、总积分：获取的各类积分合计，与等级体系关联。',
  rules_description02:'2、积分类型：根据积分获取来源，分类为“学习积分”，“贡献积分”，“主播积分”，“微课积分”，“讲师积分”，“互动积分”，可筛选查看明细。',
  rules_description03:'3、积分上限：展示每个积分的日上限。',
  rules_description04:'4、部分活动行为暂时只支持在APP端获得积分。',

  rules_description_detail:'积分规则明细：',
  rules_sort:'序号',
  rules_behavior:'活动行为',
  rules_score:'单次分值(分)',
  rules_description_type:'说明',
  rules_type_title:'类型',
  rules_maximum_points:'积分上限（每日）：'
}
